import React from "react";
import * as Sentry from "@sentry/browser";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import CssBaseline from "@material-ui/core/CssBaseline";
import UserInteraction from "../interaction/userInteraction";
import {
  displaySnackbar,
  AddTaskToTaskList,
  RemoveTaskFromTaskList,
} from "../../actions";
import { MasterContext } from "../../context/master";
import SpeedDial from "../interaction/speedDial";
import { put, takeLatest, all } from "redux-saga/effects";
import { ADD_TASK_TO_TASKLIST } from "../../constants/actionTypes";
import { useEffect } from "react";
import { PollTasks } from "../../actions/sagaActions";
import { useTranslation } from "react-i18next";

const timeStamptToDate = (timeStamp) => {
  // Create a new JavaScript Date object based on the timestamp
  // multiplied by 1000 so that the argument is in milliseconds, not seconds.
  var date = new Date(timeStamp * 1000);
  // Hours part from the timestamp
  var hours = date.getHours();

  // Minutes part from the timestamp
  var minutes = "0" + date.getMinutes();
  // Seconds part from the timestamp
  var seconds = "0" + date.getSeconds();

  // Will display time in 10:30:23 format
  var formattedTime =
    hours + ":" + minutes.substr(-2) + ":" + seconds.substr(-2);

  return date;
};

const Index = (props) => {
  const history = useHistory();
  const userAccess = useSelector((state) => state.userAccess);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  if (userAccess.token === "" && !props.LoginNotRequired)
    history.push("/login");

  useEffect(() => {
    history.location.pathname !== "/login" && dispatch(PollTasks());
  }, []);

  axios.interceptors.response.use(undefined, function (error) {
    const statusCode = error.response ? error.response.status : null;

    if (
      window.location.pathname.endsWith("/login") === false &&
      (statusCode === 401 || statusCode === 403)
    ) {
      window.localStorage.clear();
      window.location = "/login";
      return;
    }

    /*if (statusCode !== 401) {
      dispatch(displaySnackbar(t("An Error Occured"), "error"));
    } else if (statusCode >= 402) {
      dispatch(displaySnackbar(error.status.Data, "error"));
    } else if (statusCode >= 500) {
      dispatch(displaySnackbar(t("An Error Occured"), "error"));
    }asd*/

    if (statusCode > 401 && statusCode < 410) {
      if (error.response.data.Data.Message === undefined) {
        dispatch(displaySnackbar(t("An Error Occured"), "error"));
      } else {
        if (
          error.response.data.Data.MetaData === null ||
          error.response.data.Data.MetaData === undefined
        ) {
          dispatch(
            displaySnackbar(t(error.response.data.Data.Message), "error")
          );
        } else {
          dispatch(
            displaySnackbar(
              t(error.response.data.Data.Message, {
                ZoneName: error.response.data.Data.MetaData,
              }),
              "error"
            )
          );
        }
      }
    } else if (statusCode === 400) {
      debugger;
      if (error.response.data.Data === undefined) {
        dispatch(
          displaySnackbar(t(error.response.data.error_description), "error")
        );
      } else {
        if (
          error.response.data.Data.MetaData !== null ||
          error.response.data.Data.MetaData === ""
        ) {
          Sentry.withScope((scope) => {
            scope.setTag("CATEGORY", "REACT_ERROR_BOUNDARIES");
            scope.setTag("CUSTOMERID", userAccess.customerID )
            Sentry.captureException(error);
          });
          dispatch(
            displaySnackbar(
              t(error.response.data.Data.Message, {
                zonename: Object.values(error.response.data.Data.MetaData),
              }),
              "error"
            )
          );
          return error.response;
        } else {

          Sentry.withScope((scope) => {
            scope.setTag("CATEGORY", "REACT_ERROR_BOUNDARIES");
            scope.setTag("CUSTOMERID", userAccess.customerID )
            Sentry.captureException(error);
          });

          dispatch(
            displaySnackbar(t(error.response.data.Data.Message), "error")
          );
        }
      }
    } else if (statusCode > 410) {

      Sentry.withScope((scope) => {
        scope.setTag("CATEGORY", "REACT_ERROR_BOUNDARIES");
        scope.setTag("CUSTOMERID", userAccess.customerID )
        Sentry.captureException(error);
      });
      dispatch(displaySnackbar(t("An Error Occured"), "error"));
    }
    //console.table(error);

    return Promise.reject(error);
  });

  const apiCall = (endpoint, type = "GET", data = "") => {
    let headers = {
      Authorization: "bearer " + userAccess.token,
      Accept: "application/json",
    };
    headers["Content-Type"] = "application/json";

    if (endpoint === "/token")
      headers["Content-Type"] = "application/x-www-form-urlencoded";

    // ToDo : Remove cache flag block

    // CacheFlag Feature Start

    /*
     var queryParameters = [];
    var globalCachedEndPoint = [
      "/plugin/directory",
      "/ftp/password",
      "/theme/directory",
      "/php-version?phpVersion",
    ];

    var isGlobalCachedEndPoint = globalCachedEndPoint.some((pattern) => {
      var isGlobalCachedEndPoint = endpoint.includes(pattern);
      return isGlobalCachedEndPoint;
    });

    if (isGlobalCachedEndPoint === false && userAccess.accessID > 0) {
      queryParameters.push(`access_id=${userAccess.accessID}`);
      var endPointQueryParameters = queryParameters.join("&");
      endpoint = `${endpoint}?${endPointQueryParameters}`;
    }*/
    // CacheFlag Feature End

    return axios({
      method: type,
      headers: headers,
      url: process.env.REACT_APP_API_URL + endpoint,
      withCredentials: true,
      data: data,
      errorHandle: false,
    });
  };

  const GetSites = () => {
    return apiCall("/v1/sites", "GET").then((response) => {
      //console.table(response);

      var validSites = FilterValidSites(response.data.Data);
      return validSites;
    });
  };

  const FilterValidSites = (siteList) => {
    if (siteList == null) return [];
    var validSiteList = siteList.map((siteData) => {
      var filteredInstances = siteData.Instances.filter((instance) => {
        var instanceDetails = instance?.InstanceDetails?.List;
        if (instanceDetails == null || instanceDetails.length === 0)
          return false;
        return instanceDetails[0].Id > 0;
      });
      siteData.Instances = filteredInstances;
      return siteData;
    });
    return validSiteList;
  };

  const WordpressAdminPage = (jetpressGUID) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/login",
      "GET",
      ""
    ).then((response) => {
      //console.table(response);
      return response.data.Data;
    });
  };

  const ActivatePlugin = (jetpressGUID, pluginName, version) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/plugin/activate",
      "PATCH",
      { Name: pluginName, Version: version }
    ).then((response) => {
      dispatch(
        displaySnackbar(
          t("Plugin has been Activated") + " " + pluginName,
          "success"
        )
      );
      console.table(response);
      return response.statusText;
    });
  };

  const GetThumbnail = (jetpressGUID, type) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/thumbnail",
      type,
      ""
    ).then((response) => {
      //console.table(response);
      return response.data.Data;
    });
  };
  const DeactivatePlugin = (jetpressGUID, pluginName, version) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/plugin/deactivate",
      "PATCH",
      { Name: pluginName, Version: version }
    ).then((response) => {
      dispatch(
        displaySnackbar(
          t("Plugin has been Deactivated") + " " + pluginName,
          "success"
        )
      );
      //console.table(response);
      return response.statusText;
    });
  };
  const UninstallPlugin = (jetpressGUID, pluginID) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/plugin/uninstall",
      "DELETE",
      { Name: pluginID }
    ).then((response) => {
      dispatch(displaySnackbar(t("Plugin has been Removed"), "success"));
      return response.statusText;
    });
  };
  const ActivateTheme = (jetpressGUID, themeName, version) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/theme/activate",
      "PATCH",
      { Name: themeName, Version: version }
    ).then((response) => {
      dispatch(
        displaySnackbar(
          t("Theme has been Activated") + " " + themeName,
          "success"
        )
      );
      //console.table(response);
      GetSites();
      return response.statusText;
    });
  };
  const DeactivateTheme = (jetpressGUID, themeName, version) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/theme/deactivate",
      "PATCH",
      { Name: themeName, Version: version }
    ).then((response) => {
      dispatch(
        displaySnackbar(
          t("Theme has been Deactivated") + " " + themeName,
          "success"
        )
      );
      //console.table(response);
      return response.statusText;
    });
  };
  const UninstallTheme = (jetpressGUID, themeId) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/theme/uninstall",
      "DELETE",
      { Name: themeId }
    ).then((response) => {
      dispatch(displaySnackbar(t("Theme has been Removed"), "success"));
      //console.table(response);
      return response.statusText;
    });
  };
  const ResolveSecurityIssues = (jetpressGUID, issues) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/security/resolve",
      "PATCH",
      { Issues: issues }
    ).then((response) => {
      dispatch(
        displaySnackbar(t("Security Issues have been Resolved"), "success")
      );
      //console.table(response);
      return response.statusText;
    });
  };
  const RollbackResolvedSecurityIssues = (jetpressGUID, issues) => {
    return apiCall(
      "/v1/sites/" + jetpressGUID + "/wordpress/security/rollback",
      "PATCH",
      { Issues: issues }
    ).then((response) => {
      dispatch(
        displaySnackbar(
          t("Resolved Security Issues have been Rollbacked"),
          "success"
        )
      );
      //console.table(response);
      return response.statusText;
    });
  };

  const GetAccounts = () => {
    return apiCall("/v1/accounts", "GET", "").then((response) => {
      //console.table(response);
      return response.data.Data;
    });
  };

  const Login = (username, password) => {
    return apiCall(
      "/token",
      "post",
      "grant_type=password&userName=" +
        encodeURIComponent(username) +
        "&password=" +
        encodeURIComponent(password)
    );
  };



  const DeleteTask = (taskID) => {
    dispatch(RemoveTaskFromTaskList(taskID));
    return apiCall("/v1/tasks/" + taskID, "DELETE");
  };

  const GetBackups = (jetPressGuid) => {
    return apiCall(`/v1/sites/${jetPressGuid}/backups`);
  };

  const CreateBackup = (jetPressGuid, description) => {
    return apiCall(`/v1/sites/${jetPressGuid}/backups`, "POST", {
      Description: encodeURI(description),
    }).then((response) => dispatch(AddTaskToTaskList(response.data.Data)));
  };

  const RestoreBackup = (jetPressGuid, backupId) => {
    return apiCall(
      `/v1/sites/${jetPressGuid}/backups/${backupId}/restore`,
      "PUT"
    ).then((response) => {
      dispatch(AddTaskToTaskList(response.data.Data));
    });
  };

  const DeleteBackup = (jetPressGuid, backupId) => {
    return apiCall(
      `/v1/sites/${jetPressGuid}/backups/${backupId}`,
      "DELETE"
    ).then((response) => {
      try {
        dispatch(AddTaskToTaskList(response.data.Data));
      } catch (error) {}
    });
  };

  const CreateSite = (AccountId, HostName, UserName, Password) => {
    return apiCall("/v1/sites", "POST", {
      AccountId: AccountId,
      HostName: HostName,
      Password: encodeURI(Password),
      AppAdminUsername: UserName,
    }).then((response) => {
      if (response.statusText === "Bad Request") {
        return response;
      } else dispatch(AddTaskToTaskList(response.data.Data));
    });
  };

  const DeleteSite = (jetpressGUID, hostname, deleteEmail) => {
    return apiCall(`/v1/sites/${jetpressGUID}`, "DELETE", {
      HostName: hostname,
      DeleteEmailSite: deleteEmail,
    });
  };

  const CloneSite = (jetpressGUID) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/staging/clone`,
      "POST",
      ""
    );
  };

  const PassReset = (jetpressGUID) => {
    return apiCall(`/v1/sites/${jetpressGUID}/password`, "PATCH", "").then(
      (response) => {
        dispatch(
          displaySnackbar(
            t("Your new password was sent your e-mail {{email}}", {
              email: response.data.Data,
            }),
            "success"
          )
        );
      }
    );
  };

  const SyncSite = (jetpressGUID) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/staging/sync`,
      "POST",
      ""
    );
  };

  const UpdateCore = (jetpressGUID) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/core/update`,
      "PATCH",
      ""
    );
  };

  const UpdateSettings = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/core/update/settings`,
      "PATCH",
      data
    ).then((response) => {
      dispatch(
        displaySnackbar(t("Auto Update Settings are  updated"), "success")
      );
    });
  };

  const ClearCache = (jetpressGUID) => {
    return apiCall(`/v1/sites/${jetpressGUID}/wordpress/cache`, "DELETE", "");
  };

  const SearchEngine = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/mode/search-engine`,
      "PATCH",
      data
    );
  };

  const PasswordProtection = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/mode/password-protection/settings`,
      "PATCH",
      data
    );
  };

  const Maintenance = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/mode/maintenance/settings`,
      "PATCH",
      data
    );
  };

  const Debug = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/mode/debug/settings`,
      "PATCH",
      data
    );
  };

  const GetLogs = (jetpressGUID) => {
    return apiCall(`/v1/sites/${jetpressGUID}/logs`, "GET", "");
  };

  const GetPluginList = (pageNum, term, pageSize) => {
    return apiCall(
      term === " " || term === undefined || term === ""
        ? `/v1/sites/wordpress/plugin/directory/list?page=${pageNum}&pageSize=${pageSize}`
        : `/v1/sites/wordpress/plugin/directory/list?page=${pageNum}&term=${term}&pageSize=${pageSize}`,
      "GET",
      ""
    );
  };

  const GetPluginDetail = (pluginName) => {
    return apiCall(
      `/v1/sites/wordpress/plugin/directory/${pluginName}/details`,
      "GET",
      ""
    );
  };

  const InstallPlugin = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/plugin/directory/install`,
      "POST",
      data
    ).then((response) => {
      dispatch(
        displaySnackbar(t("Plugin Installed") + " " + data.Name, "success")
      );
      return response.data.Data;
    });
  };

  const GetThemeList = (pageNum, term, pageSize) => {
    return apiCall(
      term === " " || term === undefined || term === ""
        ? `/v1/sites/wordpress/theme/directory/list?page=${pageNum}&pageSize=${pageSize}`
        : `/v1/sites/wordpress/theme/directory/list?page=${pageNum}&term=${term}&pageSize=${pageSize}`,
      "GET",
      ""
    );
  };

  const InstallTheme = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/theme/directory/install`,
      "POST",
      data
    ).then((response) => {
      dispatch(
        displaySnackbar(t("Theme Installed") + " " + data.Name, "success")
      );
      return response.data.Data;
    });
  };

  const UpdateTheme = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/theme/update`,
      "PUT",
      data
    ).then((response) => {
      dispatch(AddTaskToTaskList(response.data.Data));
    });
  };

  const UpdatePlugin = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/plugin/update`,
      "PUT",
      data
    ).then((response) => {
      dispatch(AddTaskToTaskList(response.data.Data));
    });
  };

  const GetDomains = () => {
    return apiCall("/v1/domains", "GET", "").then((response) => {
      //console.table(response);
      return response.data.Data;
    });
  };

  const GetPhpVersion = (jetpressGUID) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/php-version`,
      "GET",
      ""
    ).then((response) => {
      //console.table(response);
      return response.data.Data;
    });
  };

  const GetPhpVersionList = (jetpressGUID) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/php-versions`,
      "GET",
      ""
    ).then((response) => {
      //console.table(response);
      return response.data.Data;
    });
  };

  const ChangePhpVersion = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/php-version?phpVersion=${data}`,
      "PATCH",
      ""
    ).then((response) => {
      dispatch(displaySnackbar(t("PHP Version Updated"), "success"));
    });
  };

  const Scan = (jetpressGUID) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/security/scan`,
      "GET",
      ""
    )
      .then((response) => {
        if (response.statusText !== "Bad Request") {
          dispatch(
            displaySnackbar(
              t(
                'Antivirus scan has been started, when the scan is finished, you can see the details in the "Logs" tab.'
              ),
              "success"
            )
          );
        }
      })
      .catch((error) => {
        dispatch(console.log(error));
      });
  };

  

  const GetWpLangList = (jetpressGUID) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/language`,
      "GET",
      ""
    ).then((response) => {
      //console.table(response);
      return response.data.Data;
    });
  };


  const ChangeWpLang = (jetpressGUID, data) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/wordpress/language?language=${data}`,
      "PATCH",
      ""
    ).then((response) => {
      dispatch(displaySnackbar(t("WordPress Language Updated"), "success"));
    });
  };

  const ActivateSSL = (jetpressGUID) => {
    return apiCall(
      `/v1/sites/${jetpressGUID}/free-ssl`,
      "POST",
      null
    ).then((response) => {
      dispatch(
        displaySnackbar(t("SSL Activated"), "success")
      );
      return response.data.Data;
    });
  };

  const changeSavedPreferences = (value) => {
    return apiCall(
      `/v1/customers/settings?key=setting_ui&value=${value}`,
      "POST",
      null
    ).then((response) => {
      dispatch(
        displaySnackbar(t("Preferences Settings Changed"), "success")
      );

      return response;
    });
  }

  const getSavedPreferences = (value) => {
    return apiCall(
      `/v1/customers/settings?key=${value}`,
      "GET",
      null
    ).then((response) => {
      console.log("GElen data ::: " , response)
      return response
    });
  }

  return (
    <MasterContext.Provider
      value={{
        ApiCall: apiCall,
        ActivatePlugin: ActivatePlugin,
        GetSites: GetSites,
        DeactivatePlugin: DeactivatePlugin,
        UninstallPlugin: UninstallPlugin,
        ActivateTheme: ActivateTheme,
        DeactivateTheme: DeactivateTheme,
        UninstallTheme: UninstallTheme,
        ResolveSecurityIssues: ResolveSecurityIssues,
        RollbackResolvedSecurityIssues: RollbackResolvedSecurityIssues,
        GetAccounts: GetAccounts,
        DeleteTask: DeleteTask,
        Login: Login,
        GetBackups: GetBackups,
        CreateBackup: CreateBackup,
        RestoreBackup: RestoreBackup,
        DeleteBackup: DeleteBackup,
        CreateSite: CreateSite,
        DeleteSite: DeleteSite,
        CloneSite: CloneSite,
        SyncSite: SyncSite,
        GetThumbnail: GetThumbnail,
        UpdateCore: UpdateCore,
        SearchEngine: SearchEngine,
        PasswordProtection: PasswordProtection,
        Maintenance: Maintenance,
        Debug: Debug,
        ClearCache: ClearCache,
        WordpressAdminPage: WordpressAdminPage,
        UpdateSettings: UpdateSettings,
        timeStamptToDate: timeStamptToDate,
        PassReset: PassReset,
        GetLogs: GetLogs,
        GetPluginList: GetPluginList,
        GetPluginDetail: GetPluginDetail,
        InstallPlugin: InstallPlugin,
        UpdatePlugin: UpdatePlugin,
        GetThemeList: GetThemeList,
        UpdateTheme: UpdateTheme,
        InstallTheme: InstallTheme,
        GetDomains: GetDomains,
        GetPhpVersion: GetPhpVersion,
        GetPhpVersionList: GetPhpVersionList,
        ChangePhpVersion: ChangePhpVersion,
        Scan: Scan,
        ActivateSSL: ActivateSSL,
        GetWpLangList: GetWpLangList,
        ChangeWpLang: ChangeWpLang,
        GetSavedPreferences: getSavedPreferences,
        ChangeSavedPreferences : changeSavedPreferences
      }}
    >
      <CssBaseline />
      {props.children}
      {history.location.pathname !== "/login" && <SpeedDial />}
      <UserInteraction />
    </MasterContext.Provider>
  );
};

export default Index;
